module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/map-pin.svg?b3461430b0400e996d3e3f5b5368db6d";